import { render } from "./cms-attachments.vue?vue&type=template&id=385a111f"
import script from "./cms-attachments.vue?vue&type=script&lang=js"
export * from "./cms-attachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__